// Navigation context selects public guidance only; route guards still control access.
export function helpPath(base = '/help', category = '', article = '', audience = '', language = '') {
  const path = [base, category, article].filter(Boolean).join('/');
  const query = new URLSearchParams();
  if (['patient', 'doctor', 'pharmacy'].includes(audience)) query.set('audience', audience);
  if (['fr', 'en-GB'].includes(language)) query.set('lang', language);
  return path + (query.size ? '?' + query : '');
}
export function requestedHelpAudience(search = '') {
  const value = new URLSearchParams(search).get('audience');
  return ['patient', 'doctor', 'pharmacy'].includes(value) ? value : '';
}
// Only an existing Pharmacy Help location may override the normal dashboard return.
export function pharmacyHelpReturn(value = '') {
  if (typeof value !== 'string' || !/^\/pharmacy\/help(?:\/|\?|$)/.test(value) || /[\\#]|%2f|%5c|%2e/i.test(value)) return '';
  const url = new URL(value, 'https://app.afrimed.tech');
  if (!/^\/pharmacy\/help(?:\/[a-z0-9-]+){0,2}\/?$/.test(url.pathname)) return '';
  if (!value.startsWith(url.pathname)) return ''; // Reject path normalisation/traversal.
  const query = new URLSearchParams();
  for (const [key, allowed] of [['lang',['en-GB','fr']], ['audience',['pharmacy']], ['source',['website']]]) {
    if (allowed.includes(url.searchParams.get(key))) query.set(key,url.searchParams.get(key));
  }
  return url.pathname + (query.size ? '?' + query : '');
}
